import type { Translation } from "./types";

const en: Translation = {
  home: {
    title: "Pickle - AI Photo Generator",
    subtitle: "Create stunning visuals, Generate your persona",
  },
  navigation: {
    en: "English (English)",
    kr: "Korean (한국어)",
    es: "Spanish (español)",
  },
};

export default en;
